import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _parseKeys(obj) {
  var keys = Object.keys(obj);
  if (!keys.length) return [];
  return keys.filter(function (key) {
    if (Array.isArray(obj[key])) return obj[key].length;
    return ![null, undefined].includes(obj[key]);
  });
}

function _finalizeQuery(params) {
  return '?' + params.join('&');
}

export function serializeAsQueryString(obj) {
  var params = _parseKeys(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  });

  return _finalizeQuery(params);
}
export function serializeQueryWithCommaSeparatedArray(obj) {
  var params = _parseKeys(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + obj[key];
  });

  return _finalizeQuery(params);
}
export function serializeQueryWithArray(obj) {
  var params = _parseKeys(obj).map(function (key) {
    if (Array.isArray(obj[key])) {
      return obj[key].map(function (v) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(v);
      }).join('&');
    } else return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  });

  return _finalizeQuery(params);
}
export function serializeAsFormData(obj) {
  var formData = new FormData();
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (value !== null && _typeof(value) === 'object' && !(value instanceof File)) {
      // object, array
      value = JSON.stringify(value);
    }

    if (value !== null) formData.append(key, value);
  });
  return formData;
}
export var serialize = function serialize(_ref) {
  var params = _ref.params,
      method = _ref.method,
      serializer = _ref.serializer;

  function serializeAsJSON(obj) {
    return JSON.stringify(obj);
  }

  var res;

  if (method === 'GET') {
    switch (serializer) {
      case 'QueryWithArray':
        res = serializeQueryWithArray(params);
        break;

      case 'QueryWithCommaSeparatedArray':
        res = serializeQueryWithCommaSeparatedArray(params);
        break;

      default:
        res = serializeAsQueryString(params);
        break;
    }
  } else {
    switch (serializer) {
      case 'JSON':
        res = serializeAsJSON(params);
        break;

      default:
        res = serializeAsFormData(params);
        break;
    }
  }

  return res;
};